import { Heading, Input, Modal } from '../../ui';
import { useAppSelector } from '../../app/hooks';
import { selectDataShareConsent, selectFirstCamhsChild } from '../user/selectors';
import { careTeamOptionsList } from './types';
import { Formik } from 'formik';

interface ConsentSettingsProps {
    onClose: () => void;
}

export function ConsentSettings({ onClose }: ConsentSettingsProps) {
    const dataShareConsent = useAppSelector(selectDataShareConsent) ?? [];
    const camhsChild = useAppSelector(selectFirstCamhsChild);

    return (
        <Modal show onEscapeKeyDown={onClose}>
            <Modal.Header onHide={onClose}>
                <Heading level={2}>Consent Settings</Heading>
            </Modal.Header>
            <Modal.Body>
                <div className="space-y-6">
                    {dataShareConsent.length === 0 ? (
                        <>
                            <p>You don't currently have anyone on {camhsChild?.referralName}'s Care Team.</p>
                            <p>
                                To support {camhsChild?.referralName}'s treatment, we recommend creating a care team
                                that our therapist can update as needed. This approach is clinically proven to aid
                                therapy progress. Please contact the therapist directly to help set this up.
                            </p>
                        </>
                    ) : (
                        <>
                            <p>
                                The following people have permission to receive letters regarding{' '}
                                {camhsChild?.referralName} and family’s needs:
                            </p>
                            <Formik
                                initialValues={{}}
                                onSubmit={() => {
                                    return;
                                }}
                            >
                                {() => {
                                    return dataShareConsent.map(({ recipientType, recipientName, recipientEmail }) => {
                                        return (
                                            <div className="space-y-4" key={recipientType}>
                                                <strong>
                                                    {
                                                        careTeamOptionsList.find(
                                                            (item) => item.recipientType === recipientType
                                                        )?.label
                                                    }
                                                </strong>
                                                <div className="flex gap-4">
                                                    <div className="flex-1">
                                                        <Input
                                                            name={`${recipientType}.name`}
                                                            type="text"
                                                            value={recipientName ?? ''}
                                                            label={'Name'}
                                                            hideValidationIcon
                                                            disabled
                                                        ></Input>
                                                    </div>
                                                    <div className="flex-1">
                                                        <Input
                                                            name={`${recipientType}.email`}
                                                            type="text"
                                                            value={recipientEmail ?? ''}
                                                            label={'Email'}
                                                            hideValidationIcon
                                                            disabled
                                                        ></Input>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    });
                                }}
                            </Formik>
                            <p>
                                To revoke consent for the treatment of the child, please get in touch with the therapist
                                as soon as possible to let them know that you would like to cease treatment.
                            </p>
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}
